import { cn, Link } from '@reelplicate/ui';
import { type ReactNode, useId } from 'react';
import { Link as RouterLink } from 'react-router';

/**
 * A Home section card (Figma "Needs your review", "Competitors", "Coming up"):
 * bg/surface, 1px border/subtle, radius 2xl, with a card header - Heading/H4
 * title, optional badge, Caption subtitle and a brand Link on the right.
 */
export function Panel({
  title,
  badge,
  subtitle,
  link,
  className,
  children,
}: {
  title: string;
  badge?: ReactNode;
  subtitle: ReactNode;
  link?: { label: string; to: string };
  className?: string;
  children: ReactNode;
}) {
  const id = useId();
  return (
    <section
      aria-labelledby={id}
      className={cn(
        'bg-bg-surface border-border-subtle flex flex-col rounded-2xl border p-6',
        className,
      )}
    >
      <header className="flex items-center gap-2">
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <div className="flex items-center gap-2">
            <h2 id={id} className="text-heading-h4 text-text-primary">
              {title}
            </h2>
            {badge}
          </div>
          <p className="text-caption text-text-secondary">{subtitle}</p>
        </div>
        {link && (
          <Link asChild size="sm">
            <RouterLink to={link.to}>{link.label}</RouterLink>
          </Link>
        )}
      </header>
      {children}
    </section>
  );
}
